import { connect } from 'react-redux';
import View from './component';
import { setMessage } from '../../../Notification/actions';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  alert: (message) => dispatch(setMessage({ message, duration: 3000 })),
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
